// Deadline checker utility for KSR Hackathon
export const HACKATHON_DEADLINE = new Date('2026-06-20T23:59:59'); // June 18th, 2026 11:59 PM IST

export const checkDeadline = () => {
  const currentTime = new Date();
  return currentTime <= HACKATHON_DEADLINE;
};

export const getDeadlineStatus = () => {
  const isOpen = checkDeadline();
  
  if (!isOpen) {
    return {
      isOpen: false,
      message: "Registration deadline has passed. The hackathon is no longer accepting new submissions. Time's up!"
    };
  }
  
  return {
    isOpen: true,
    message: null
  };
};